import { ElementCssClassCreator, TableElementFormatter } from 'src/app/shared/model/table-element-formatter';
import { AdditionalInfoImpl } from '../model/status/additional-info-impl';

export class DeviceLocationFormatter implements TableElementFormatter<AdditionalInfoImpl> {

    createElementCssClasses: ElementCssClassCreator<AdditionalInfoImpl> = (data: AdditionalInfoImpl): string => {
        if (!data.hasLocation) {
            return 'hidden';
        }
    };

}
